var _path, _path2, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOffers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.57914 2.31123C8.34038 1.47175 9.65962 1.47175 10.4209 2.31123C11.0074 2.95808 11.8528 3.30825 12.725 3.26562C13.8569 3.2103 14.7897 4.14314 14.7344 5.27503C14.6917 6.14718 15.0419 6.99258 15.6888 7.57914C16.5283 8.34038 16.5283 9.65962 15.6888 10.4209C15.0419 11.0074 14.6917 11.8528 14.7344 12.725C14.7897 13.8569 13.8569 14.7897 12.725 14.7344C11.8528 14.6917 11.0074 15.0419 10.4209 15.6888C9.65962 16.5283 8.34038 16.5283 7.57914 15.6888C6.99258 15.0419 6.14718 14.6917 5.27503 14.7344C4.14314 14.7897 3.2103 13.8569 3.26562 12.725C3.30825 11.8528 2.95808 11.0074 2.31123 10.4209C1.47175 9.65962 1.47175 8.34038 2.31123 7.57914C2.95808 6.99258 3.30825 6.14718 3.26562 5.27503C3.2103 4.14314 4.14314 3.2103 5.27503 3.26562C6.14718 3.30825 6.99258 2.95808 7.57914 2.31123Z",
    stroke: "#5267A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12.0003L12 6.85742",
    stroke: "#5267A9",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.28571,
    cy: 7.28571,
    r: 0.785714,
    stroke: "#5267A9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.7144,
    cy: 11.5709,
    r: 0.785714,
    stroke: "#5267A9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffers);
export default __webpack_public_path__ + "static/media/offers.c7bec235182830bfdda823ac7262cc91.svg";
export { ForwardRef as ReactComponent };